import { useEffect, useMemo, useState } from 'react';

interface UseEnteredViewportArgs<TElement extends HTMLElement = HTMLElement>{
    element: TElement | null;
    options?: IntersectionObserverInit;
}

export default function useEnteredViewport<TElement extends HTMLElement = HTMLElement>(args: UseEnteredViewportArgs<TElement>) {
    const { element, options } = args;

    const [ enteredViewport, setEnteredViewport ] = useState(false);

    const observer = useMemo(() => (
        new IntersectionObserver(
            ([ entry ]) => {
                setEnteredViewport(entry.isIntersecting);
            },
            options
        )
    ), [ options ]);

    useEffect(() => {
        if (!element) {
            return;
        }

        observer.observe(element);

        return () => {
            observer.disconnect();
        };
    }, [ observer, element ]);

    return enteredViewport;
}
